export class BaseServiceErrorResolverService {

  constructor() { }

  defaultMessage = 'Problem bei der Bedienung, bitte versuchen Sie es erneut';

  codes = {

  };

  public getMessage(reason: string, message?: string) {
    const fromApi = typeof message === 'string' ? message.trim() : '';
    if (fromApi && !fromApi.startsWith('Http failure')) {
      return fromApi;
    }

    if (reason === null || reason === undefined) {
      return this.defaultMessage;
    }

    if (this.codes.hasOwnProperty(reason)) {
      return this.codes[reason];
    } else {
      return this.defaultMessage;
    }
  }
}

